import { useEffect } from 'react';

const DEFAULT_INACTIVITY_DELAY = 300000;

const useRecaptchaTimer = (callback) => {
  useEffect(() => {
    let timer;

    const resetTimer = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        callback();
      }, DEFAULT_INACTIVITY_DELAY);
    };

    const events = ['mousemove', 'keypress', 'scroll', 'click'];

    events.forEach((event) => {
      window.addEventListener(event, resetTimer);
    });

    resetTimer();

    return () => {
      clearTimeout(timer);
      events.forEach((event) => {
        window.removeEventListener(event, resetTimer);
      });
    };
  }, [callback]);
};

export default useRecaptchaTimer;
